import { DealData } from '../types';
import {
  R_AND_D_DEAL_PIPELINES,
  SALES_DEAL_PIPELINE,
  TAXES_DEAL_PIPELINES,
} from '../constants';

const linkTaxesOrRAndDValidStatus = ['closedwon', 'churned', 'completed'];
const linkValidStatus = ['closedwon', 'churned'];

const sortDealsByClosedDate = (prev: DealData, curr: DealData) => {
  if (prev.closed_date === null && curr.closed_date === null) {
    return 0;
  }
  if (prev.closed_date === null) {
    return 1;
  }
  if (curr.closed_date === null) {
    return -1;
  }
  return (
    new Date(curr.closed_date).getTime() - new Date(prev.closed_date).getTime()
  );
};

const filterDealsByPipeline = (
  deals: DealData[],
  pipeline: string[],
  sort: boolean
) =>
  deals
    ?.filter(
      (deal) =>
        deal?.status &&
        linkTaxesOrRAndDValidStatus.includes(deal.status) &&
        pipeline.includes(deal?.pipeline)
    )
    .sort(sort ? sortDealsByClosedDate : () => 0);

export const filteredSalesDeals = (deals: DealData[], sort: boolean) =>
  deals
    ?.filter(
      (deal) =>
        deal?.status &&
        linkValidStatus.includes(deal.status) &&
        deal?.pipeline === SALES_DEAL_PIPELINE
    )
    .sort(sort ? sortDealsByClosedDate : () => 0);

export const filteredTaxesDeals = (deals: DealData[], sort: boolean) =>
  filterDealsByPipeline(deals, TAXES_DEAL_PIPELINES, sort);

export const filteredRAndDDeals = (deals: DealData[], sort: boolean) =>
  filterDealsByPipeline(deals, R_AND_D_DEAL_PIPELINES, sort);

export default { filteredSalesDeals, filteredTaxesDeals, filteredRAndDDeals };
